module.exports = __webpack_public_path__ + "img/newpagebg4.6e4cc33d.jpg";